import { MatchOffer } from 'types/MatchOffer';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import styles from './SportsBettingSearchResults.module.css';
import { useTranslation } from 'react-i18next';
import { MatchList } from 'components/MatchList/MatchList';
import { ResultsMatchTable } from 'components/ResultsMatchTable/ResultsMatchTable';

export interface SportsBettingSearchResults {
  query: string;
  results: Map<number, MatchOffer[]> | null;
}

interface Props {
  results: SportsBettingSearchResults;
  closeSearchResults: () => void;
  /** Results page: FT/HT/Tip/Odd grid instead of prematch quote rows. */
  useResultsTable?: boolean;
}

export const SportsBettingSearchResults = ({
  results,
  closeSearchResults,
  useResultsTable = false,
}: Props) => {
  const { t } = useTranslation();

  if (!results.results) {
    return <></>;
  }

  const searchBlocks = Array.from(results.results.values()).map(
    (x: MatchOffer[], idx) => ({
      matches: x,
      leagueId: -(idx + 1),
      sportId: x[0].league.sport,
    })
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span>
          <ThemeIcon
            icon="search"
            alt="Search results"
            variant="inline"
            tone="chrome"
          />
          {t('search_results_message')}
          <span>{results.query}</span>
        </span>
        <ThemeIcon
          icon="remove"
          alt="Remove"
          variant="inline"
          tone="chrome"
          className={styles.closeButton}
          onClick={closeSearchResults}
        />
      </div>
      {useResultsTable ? (
        <ResultsMatchTable blocks={searchBlocks} searchMode />
      ) : (
        Array.from(results.results.values()).map((x: MatchOffer[]) => (
          <MatchList
            leagueName={x[0].league.name}
            events={x}
            searchResults
            key={x[0].league.name}
          />
        ))
      )}
    </div>
  );
};
